import Core from "@/modules/core/service/Core";

const deadline = function (months, day, month, full) {
    if (!day) {
        return "";
    }
    return day + ". " +  (full ? months[month].name : month+1);
};

const cacluateDeadlines = function (incr, day, month, months) {
    if (month < 0) {
        return null;
    }

    let result = "";
    for (let m = 0; m < 12;) {
        result = result + deadline(months, day, month, true)
        m = m + incr;
        month = month + incr;
        month = month % 12;

        if (m < 12) {
            result = result + ", "
        }
    }

    return result;
}


export default {
    url: {
        site             : "/api/site/",
        sitesearch       : "/api/site/search",
        sitecontactsearch: "/api/site/search/contact/{0}",
        enums            : "/api/masterdata/enums",
        contract         : "/api/customer/{0}/contract",
    },

    stamp: {
        stampUrl    : "/api/user/stamp/{0}",
        signatureUrl: "/api/user/signature",
        adjustUrl   : "/api/user/stamp/adjust?delta=",

        prepare (id, success) {
            Core.transfer.load(this.stampUrl.replace("{0}", id), data => {
                success(data);
            });
        },

        prepareUser (user, id, success) {
            Core.transfer.load(this.stampUrl.replace("{0}", id) + "?user=" + user, data => {
                success(data);
            });
        },

        loadSignature (success, error) {
            Core.transfer.load(this.signatureUrl, success, error);
        },

        loadUserSignature (user, success, error) {
            Core.transfer.load(this.signatureUrl + "?user=" + user, success, error);
        },

        uploadSignature (file, success, error) {
            Core.transfer.upload(this.signatureUrl, file, success, error);
        },

        adjustSignature (distance, success, error) {
            Core.transfer.call(this.adjustUrl + distance, null, success, error);
        },

        adjustUserSignature (user, distance, success, error) {
            Core.transfer.call(this.adjustUrl + distance + "&user=" + user, null, success, error);
        }
    },

    globalstamp: {
        url  : {
            image: "/api/preferences/globalstamp/",
            imageall: "/api/preferences/globalstamp",
            store : "/api/preferences/globalstamp/{0}"
        },

        loadAll () {
            return Core.method.get(this.url.imageall);
        },

        load (type, success, error) {
            Core.transfer.load(this.url.image + type, success, error);
        },

        loadStamp (type, success, error) {
            Core.transfer.load(this.url.image + type, success, error);
        },

        upload (type, file, success, error) {
            Core.transfer.upload(this.url.image + type, file, success, error);
        },

        save (stamp) {
            return Core.method.put(this.url.store, stamp, stamp.id);
        }
    },

    contract: {
        mnt: {
            deadlines (contract, months) {
                if (!contract.invoiceFrequency) {
                    return null;
                }

                const frequency = contract.invoiceFrequency.id;
                const month = contract.invoiceMonth-1;
                const day   = contract.invoiceDay ;

                switch (frequency) {
                    case 1:
                        return cacluateDeadlines (12 / contract.countPerYear, day, month, months);
                    case 2:
                        return cacluateDeadlines (1, day, month, months);
                    case 3:
                        return cacluateDeadlines (3, day, month, months);
                    case 4:
                        return cacluateDeadlines (6, day, month, months);
                    case 5:
                        return cacluateDeadlines (12, day, month, months);
                }

                return null;
            }
        }
    }
}